import swal from "sweetalert2";
import { ESTIMATE_STATUS_COMPLETED } from "../constants/estimates";
import { INSPECTION_STATUS_COMPLETED } from "../constants/inspections";
import { REPAIR_STATUS_COMPLETED } from "../constants/repairs";

export default {
  methods: {
    canGenerateInspectionReport: function (inspection) {
      return (
        !!inspection &&
        inspection.status == INSPECTION_STATUS_COMPLETED &&
        this.$currentUserCan(this.$permissions.PERM_VIEW_INSPECTIONS)
      );
    },

    async downloadInspectionReport(inspection) {
      if (!this.canGenerateInspectionReport(inspection)) return;

      swal.fire({
        // title: `Chargement`,
        onBeforeOpen: () => {
          swal.showLoading();
        },
      });
      try {
        const response = await this.$store.dispatch(
          "inspections/getReport",
          inspection.id
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${inspection.code}-report${
            inspection.is_repaired
              ? " (" + this.$t("INSPECTIONS.REPAIRED") + ")"
              : ""
          }.pdf`
        );
        document.body.appendChild(link);
        link.click();
        swal.close();
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.setApiValidation(error.response.data.errors);
        swal.close();
      }
    },

    canGenerateEstimationReport: function (estimate) {
      return (
        !!estimate &&
        estimate.status == ESTIMATE_STATUS_COMPLETED &&
        this.$currentUserCan(this.$permissions.PERM_VIEW_ESTIMATIONS)
      );
    },

    async downloadEstimationReport(estimate) {
      if (!this.canGenerateEstimationReport(estimate)) return;

      swal.fire({
        // title: `Chargement`,
        onBeforeOpen: () => {
          swal.showLoading();
        },
      });
      try {
        const response = await this.$store.dispatch(
          "estimations/getReport",
          estimate.id
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${estimate.code}-report.pdf`);
        document.body.appendChild(link);
        link.click();
        swal.close();
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.setApiValidation(error.response.data.errors);
        swal.close();
      }
    },

    canGenerateRepairReport: function (repair) {
      return (
        !!repair &&
        repair.status == REPAIR_STATUS_COMPLETED &&
        this.$currentUserCan(this.$permissions.PERM_VIEW_REPAIRS)
      );
    },

    async downloadRepairReport(repair) {
      if (!this.canGenerateRepairReport(repair)) return;

      swal.fire({
        // title: `Chargement`,
        onBeforeOpen: () => {
          swal.showLoading();
        },
      });
      try {
        const response = await this.$store.dispatch(
          "repairs/getReport",
          repair.id
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${repair.code}-report.pdf`);
        document.body.appendChild(link);
        link.click();
        swal.close();
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.setApiValidation(error.response.data.errors);
        swal.close();
      }
    },
  },
};
